module.exports = __webpack_public_path__ + "img/sponsorW01.d7c90aec.png";